import React, { useContext, useState } from 'react';
import { isFunction } from 'extra/functions';

import ModalMessage from 'components/modal/ModalMessage';
import ModalLoader from 'components/general/ModalLoader';

const NotificationContext = React.createContext();
export default NotificationContext;

export const NotificationContextProvider = props => {
	
	const [ modal_message, setModalMessage ] = useState( null );
	const [ modal_loader, setModalLoader ] = useState( null );

	return (
		<NotificationContext.Provider value={{
			setNotification: p => setModalMessage( p ),
			showModalLoader: s => setModalLoader( s )
		}}>

			{ props.children }

			{ !!modal_loader && <ModalLoader/> }

			{ modal_message && 
				<ModalMessage
					{...modal_message }
					closeHandler={() => {
						isFunction( modal_message.closeHandler ) && modal_message.closeHandler();
						setModalMessage( null )
					}}
				/>
			}

		</NotificationContext.Provider>
	)
}


export const useNotification = () => {
	const { setNotification } = useContext( NotificationContext );
	return setNotification;
}

export const useModalLoader = () => {
	const { showModalLoader } = useContext( NotificationContext );
	return showModalLoader;
}
